import { RxHamburgerMenu } from "react-icons/rx";
import { useDashboard } from "../../contexts/dashboard.context";

const liStyles =
  "hover:cursor-pointer hover:text-light-gray w-fit font-inter text-md mb-2 ";

const Sidemenu = () => {
  const { page, changePage } = useDashboard();

  const handleSidemenuClick = (dashboardPage: string) => {
    changePage(dashboardPage);
  };

  return (
    <div>
      <p className="flex flex-row items-center gap-2 text-light-gray mb-4">
        <RxHamburgerMenu color="#909090" />
        Menu
      </p>
      <ul>
        <li
          className={liStyles + `${page === "MainData" ? "font-bold" : ""}`}
          onClick={() => handleSidemenuClick("MainData")}
        >
          Main data
        </li>
        <li
          className={liStyles + `${page === "Expenses" ? "font-bold" : ""}`}
          onClick={() => handleSidemenuClick("Expenses")}
        >
          Expenses
        </li>
        <li
          className={liStyles + `${page === "Income" ? "font-bold" : ""}`}
          onClick={() => handleSidemenuClick("Income")}
        >
          Income
        </li>
      </ul>
    </div>
  );
};

export default Sidemenu;
